import { type ComponentPropsWithRef } from "react";

export interface StringToJSXProps extends ComponentPropsWithRef<"div"> {
  text: string;
  tag?: "div" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export default function StringToJSX(props: StringToJSXProps) {
  const { text, tag: Tag = "div", ...restProps } = props;

  return <Tag {...restProps} dangerouslySetInnerHTML={{ __html: text }} />;
}
